import { ActionTypes } from "../../constants/ActionTypes";
import { ILetterReferTypesStatics } from "../../interfaces/LetterReferTypesStatics";

// letterReferTypesStatics
export const onClearLetterReferInboxTypesStatics = () => {
    return {
        type: ActionTypes.CLEAR_Letter_Refer_Inbox_Types_Statics,
    };
};

export const onGetLetterReferInboxTypesStatics = () => {
    return {
        type: ActionTypes.GET_Letter_Refer_Inbox_Types_Statics,
    };
};

export const fetchLetterReferTypesInboxStaticsSuccess = (letterReferInboxTypesStatics: ILetterReferTypesStatics[]) => {
    return {
        type: ActionTypes.FETCH_Letter_Refer_Inbox_Types_Statics_SUCCESS,
        payload: letterReferInboxTypesStatics,
    };
};

//SendBox
export const onClearLetterReferSendBoxTypesStatics = () => {
    return {
        type: ActionTypes.CLEAR_Letter_Refer_SendBox_Types_Statics,
    };
}

export const onGetLetterReferSendBoxTypesStatics = () => {
    return {
        type: ActionTypes.GET_Letter_Refer_SendBox_Types_Statics,
    };
};

export const fetchLetterReferTypesSendBoxStaticsSuccess = (letterReferSendBoxTypesStatics: ILetterReferTypesStatics[]) => {
    return {
        type: ActionTypes.FETCH_Letter_Refer_Sendbox_Types_Statics_SUCCESS,
        payload: letterReferSendBoxTypesStatics,
    };
};